import type { ReactNode } from 'react';

// First piece of the retro-OS kit: a hard-cornered window with a title bar.
export function Window({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="win">
      <header className="win-title">
        <span className="win-title-text">{title}</span>
        <span className="win-title-controls" aria-hidden>
          <i />
          <i />
        </span>
      </header>
      <div className="win-body">{children}</div>
    </section>
  );
}
